import React, {

    useState,

    useEffect,

    useRef

}

from "react";

import ImageGallery

from "./ImageGallery";

import {

    FontAwesomeIcon

}

from "@fortawesome/react-fontawesome";

import {

    faExpand,

    faChevronRight,

    faChevronLeft

}

from "@fortawesome/free-solid-svg-icons";

import {

    functions

}

from "../constants/common-functions";


export default function ImageViewer(

{

    photos = []

})

{

    //--------------------------------------------------------
    // State
    //--------------------------------------------------------

    const [selectedPhoto, setSelectedPhoto] =

        useState(null);

    const [imageUrl, setImageUrl] =

        useState(null);

    const [showGallery, setShowGallery] =

        useState(false);


    //--------------------------------------------------------
    // References
    //--------------------------------------------------------

    const thumbnailStrip =

        useRef(null);


    //--------------------------------------------------------
    // Initial image
    //--------------------------------------------------------

    useEffect(

        function()

        {

            if(photos.length === 0)

            {

                return;

            }

            const main =

                photos.find(

                    function(photo)

                    {

                        return (

                            photo.fileName

                                .toLowerCase()

                            ===

                            "main.jpg"

                        );

                    }

                )

                ||

                photos[0];

            openPhoto(

                main

            );

        },

        [photos]

    );


    //--------------------------------------------------------
    // Load thumbnail images
    //--------------------------------------------------------

    useEffect(

        function()

        {

            if(photos.length === 0)

            {

                return;

            }

            photos.forEach(

                function(photo)

                {

                    functions.getBlobFromAjax(

                        "/resolutionsoftwareplatform/api/sharepoint/file/"

                        +

                        photo.sharePointId,

                        function(blob)

                        {

                            photo.url =

                                window.URL.createObjectURL(

                                    blob

                                );

                            if(

                                photo.fileName

                                    .toLowerCase()

                                ===

                                "main.jpg"

                            )

                            {

                                setSelectedPhoto(

                                    photo

                                );

                                setImageUrl(

                                    photo.url

                                );

                            }

                        }

                    );

                }

            );

        },

        [photos]

    );


    //--------------------------------------------------------
    // Open photo
    //--------------------------------------------------------

    const openPhoto =

        function(photo)

        {

            if(!photo)

            {

                return;

            }

            setSelectedPhoto(

                photo

            );

            //------------------------------------------------
            // Already loaded
            //------------------------------------------------

            if(photo.url)

            {

                setImageUrl(

                    photo.url

                );

                return;

            }


            //------------------------------------------------
            // Load image
            //------------------------------------------------

            functions.getBlobFromAjax(

                "/resolutionsoftwareplatform/api/sharepoint/file/"

                +

                photo.sharePointId,

                function(blob)

                {

                    const url =

                        window.URL.createObjectURL(

                            blob

                        );

                    photo.url =

                        url;

                    setImageUrl(

                        url

                    );

                }

            );

        };


    //--------------------------------------------------------
    // Scroll thumbnails left
    //--------------------------------------------------------

    const scrollLeft =

        function()

        {

            if(thumbnailStrip.current)

            {

                thumbnailStrip.current.scrollBy(

                    {

                        left: -220,

                        behavior: "smooth"

                    }

                );

            }

        };


    //--------------------------------------------------------
    // Scroll thumbnails right
    //--------------------------------------------------------

    const scrollRight =

        function()

        {

            if(thumbnailStrip.current)

            {

                thumbnailStrip.current.scrollBy(

                    {

                        left: 220,

                        behavior: "smooth"

                    }

                );

            }

        };


    //========================================================
    // Styles
    //========================================================

    //--------------------------------------------------------
    // Main container
    //--------------------------------------------------------

    const viewerContainer =

    {

        width:
            "100%",

        height:
            "350px",

        display:
            "flex",

        flexDirection:
            "column",

        //----------------------------------------------------
        // Graphite structure
        //----------------------------------------------------

        background:
            `linear-gradient(
                145deg,
                #292d31 0%,
                #181c1f 55%,
                #0b0d0f 100%
            )`,

        overflow:
            "hidden",

        border:
            "1px solid rgba(255,255,255,0.08)",

        boxSizing:
            "border-box",

        boxShadow:
            "inset 0 1px 0 rgba(255,255,255,0.05)"
    };


    //--------------------------------------------------------
    // Hero image
    //--------------------------------------------------------

    const heroContainer =

    {

        flex:
            1,

        display:
            "flex",

        alignItems:
            "center",

        justifyContent:
            "center",

        overflow:
            "hidden",

        background:
            "#101315",

        borderBottom:
            "1px solid rgba(255,255,255,0.09)"
    };


    const heroImage =

    {

        width:
            "100%",

        height:
            "100%",

        objectFit:
            "cover",

        transition:
            "opacity 0.35s ease"
    };


    const noImage =

    {

        color:
            "rgba(255,255,255,0.58)",

        fontSize:
            "14px"
    };


    //--------------------------------------------------------
    // Thumbnail strip
    //--------------------------------------------------------

    const thumbnailContainer =

    {

        display:
            "flex",

        gap:
            "10px",

        padding:
            "14px",

        overflowX:
            "auto",

        scrollBehavior:
            "smooth",

        scrollbarWidth:
            "none",

        msOverflowStyle:
            "none",

        background:
            "rgba(0,0,0,0.22)",

        borderBottom:
            "1px solid rgba(255,255,255,0.08)"
    };


    //--------------------------------------------------------
    // Thumbnail
    //--------------------------------------------------------

    const getThumbnailStyle =

        function(photo)

        {

            const selected =

                selectedPhoto

                &&

                selectedPhoto.sharePointId

                ===

                photo.sharePointId;

            return {

                minWidth:
                    "122px",

                width:
                    "122px",

                height:
                    "62px",

                overflow:
                    "hidden",

                cursor:
                    "pointer",

                background:
                    "#101315",

                //------------------------------------------------
                // Blue now means selected
                //------------------------------------------------

                border:

                    selected

                        ?

                        "2px solid #45afe0"

                        :

                        "2px solid rgba(255,255,255,0.08)",

                opacity:

                    selected

                        ?

                        1

                        :

                        0.72,

                boxSizing:
                    "border-box",

                boxShadow:

                    selected

                        ?

                        "0 0 12px rgba(69,175,224,0.22)"

                        :

                        "none",

                transition:
                    "opacity 0.18s ease, "
                    +
                    "border 0.18s ease, "
                    +
                    "box-shadow 0.18s ease"

            };

        };


    const thumbnailImage =

    {

        width:
            "100%",

        height:
            "100%",

        objectFit:
            "cover",

        display:
            "block"
    };


    //--------------------------------------------------------
    // Footer
    //--------------------------------------------------------

    const footer =

    {

        height:
            "48px",

        minHeight:
            "48px",

        display:
            "flex",

        alignItems:
            "center",

        justifyContent:
            "space-between",

        padding:
            "0 18px",

        background:
            `linear-gradient(
                180deg,
                #222629 0%,
                #121517 100%
            )`,

        borderTop:
            "1px solid rgba(255,255,255,0.08)",

        boxShadow:
            "inset 0 1px 0 rgba(255,255,255,0.03)"
    };


    //--------------------------------------------------------
    // Footer arrows
    //--------------------------------------------------------

    const arrowStyle =

    {

        cursor:
            "pointer",

        //----------------------------------------------------
        // Action accent
        //----------------------------------------------------

        color:
            "#45afe0",

        fontSize:
            "14px",

        opacity:
            0.90,

        transition:
            "opacity 0.18s ease"
    };


    //--------------------------------------------------------
    // Gallery button
    //--------------------------------------------------------

    const galleryButton =

    {

        display:
            "flex",

        alignItems:
            "center",

        //----------------------------------------------------
        // Action accent
        //----------------------------------------------------

        color:
            "#45afe0",

        cursor:
            "pointer",

        fontWeight:
            600,

        fontSize:
            "13px",

        letterSpacing:
            "0.1px"
    };


    //========================================================
    // Render
    //========================================================

    return (

        <div style={viewerContainer}>


            {/* ================================================
                HERO IMAGE
            ================================================= */}

            <div style={heroContainer}>

                {

                    imageUrl

                    ?

                    <img

                        src={imageUrl}

                        alt="Building"

                        style={heroImage}

                    />

                    :

                    <div style={noImage}>

                        No Image

                    </div>

                }

            </div>


            {/* ================================================
                THUMBNAILS
            ================================================= */}

            <div

                ref={thumbnailStrip}

                style={thumbnailContainer}

            >

                {

                    photos.map(

                        function(photo)

                        {

                            return (

                                <div

                                    key={
                                        photo.sharePointId
                                    }

                                    style={
                                        getThumbnailStyle(
                                            photo
                                        )
                                    }

                                    onClick={

                                        function()

                                        {

                                            openPhoto(

                                                photo

                                            );

                                        }

                                    }

                                >

                                    {

                                        photo.url

                                        &&

                                        <img

                                            src={
                                                photo.url
                                            }

                                            alt={
                                                photo.fileName
                                            }

                                            style={
                                                thumbnailImage
                                            }

                                        />

                                    }

                                </div>

                            );

                        }

                    )

                }

            </div>


            {/* ================================================
                FOOTER
            ================================================= */}

            <div style={footer}>


                {/* --------------------------------------------
                    Previous
                --------------------------------------------- */}

                <FontAwesomeIcon

                    icon={
                        faChevronLeft
                    }

                    onClick={
                        scrollLeft
                    }

                    style={
                        arrowStyle
                    }

                />


                {/* --------------------------------------------
                    Gallery
                --------------------------------------------- */}

                <div

                    style={
                        galleryButton
                    }

                    onClick={

                        function()

                        {

                            setShowGallery(

                                true

                            );

                        }

                    }

                >

                    <FontAwesomeIcon

                        icon={
                            faExpand
                        }

                        style={{

                            marginRight:
                                "8px"

                        }}

                    />

                    View Gallery

                </div>


                {/* --------------------------------------------
                    Next
                --------------------------------------------- */}

                <FontAwesomeIcon

                    icon={
                        faChevronRight
                    }

                    onClick={
                        scrollRight
                    }

                    style={
                        arrowStyle
                    }

                />

            </div>


            {/* ================================================
                FULL GALLERY
            ================================================= */}

            <ImageGallery

                visible={
                    showGallery
                }

                photos={
                    photos
                }

                selectedPhoto={
                    selectedPhoto
                }

                onSelectPhoto={

                    function(photo)

                    {

                        setSelectedPhoto(

                            photo

                        );

                        setImageUrl(

                            photo.url

                        );

                    }

                }

                onClose={

                    function()

                    {

                        setShowGallery(

                            false

                        );

                    }

                }

            />

        </div>

    );

}